import { Route } from "react-router-dom";
import { ProtectedRoute } from "~/context/ProtectedRoute";
import {
  AddServiceRequestPageAction,
  AddServiceRequestPageLoader,
} from "./AddServiceRequestPage/loaders";
import { AddServiceRequestPage } from "./AddServiceRequestPage";
import {
  ServiceRequestDetailsPageAction,
  ServiceRequestDetailsPageLoader,
} from "./ServiceRequestDetailsPage/loaders";
import { ServiceRequestDetailsPage } from "./ServiceRequestDetailsPage";
import { ServiceRequestTablePageLoader } from "./ServiceRequestTablePage/loaders";
import { ServiceRequestTablePage } from "./ServiceRequestTablePage";
import * as APITypes from "~/API";
import { ROUTES } from "~/utils";

export const ServiceRequestPagesRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.serviceRequestNew}
        loader={AddServiceRequestPageLoader}
        action={AddServiceRequestPageAction}
        element={
          <ProtectedRoute roles={[APITypes.TenantStatusType.Active]}>
            <AddServiceRequestPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.serviceRequestTablePage}
        loader={ServiceRequestTablePageLoader}
        element={
          <ProtectedRoute roles={[APITypes.TenantStatusType.Active]}>
            <ServiceRequestTablePage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.serviceRequestDetails}
        loader={ServiceRequestDetailsPageLoader}
        action={ServiceRequestDetailsPageAction}
        element={
          <ProtectedRoute roles={[APITypes.TenantStatusType.Active]}>
            <ServiceRequestDetailsPage />
          </ProtectedRoute>
        }
      />
    </>
  );
};
